import { render, staticRenderFns } from "./SubFees.vue?vue&type=template&id=130958b6&scoped=true&"
import script from "./SubFees.vue?vue&type=script&lang=js&"
export * from "./SubFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130958b6",
  null
  
)

export default component.exports